import { pmFetchJsonResult, type PmFetchJsonResult } from "@penmate/react-shared/api/pmFetch";

export type SmsVerificationResponse = { success?: boolean; [key: string]: any };

export async function requestSmsVerification(args: {
  phoneNumber: string;
}): Promise<PmFetchJsonResult<SmsVerificationResponse>> {
  return await pmFetchJsonResult<SmsVerificationResponse>("/sms-verification", {
    method: "POST",
    body: { phone_number: args.phoneNumber },
  });
}

export async function confirmSmsVerification(args: {
  phoneNumber: string;
  code: string;
}): Promise<PmFetchJsonResult<SmsVerificationResponse>> {
  return await pmFetchJsonResult<SmsVerificationResponse>("/sms-verification-confirm", {
    method: "POST",
    body: { phone_number: args.phoneNumber, code: args.code },
  });
}

